function CabinLakescapeAccent({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 1200 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      <path
        d="M280 85 L300 40 L320 85"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.15"
      />
      <path
        d="M295 55 L300 30 L305 55"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        opacity="0.12"
      />
      <path
        d="M240 90 L250 50 L260 90"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        opacity="0.1"
      />
      <path
        d="M340 88 L355 42 L370 88"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        opacity="0.1"
      />
      <path
        d="M360 90 L368 60 L376 90"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
        opacity="0.08"
      />
      <path
        d="M220 92 L228 68 L236 92"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
        opacity="0.08"
      />
      <path
        d="M270 70 L300 20 L330 70 L270 70Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        opacity="0.1"
      />
      <rect
        x="288"
        y="70"
        width="24"
        height="18"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
        opacity="0.08"
      />
      <rect
        x="294"
        y="74"
        width="5"
        height="7"
        stroke="currentColor"
        strokeWidth="0.8"
        fill="none"
        opacity="0.06"
      />
      <rect
        x="302"
        y="74"
        width="5"
        height="7"
        stroke="currentColor"
        strokeWidth="0.8"
        fill="none"
        opacity="0.06"
      />
      <path
        d="M0 95 Q200 80 400 92 Q600 100 800 90 Q1000 82 1200 95"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        opacity="0.08"
      />
      <path
        d="M0 100 Q300 88 600 98 Q900 105 1200 96"
        stroke="currentColor"
        strokeWidth="0.8"
        fill="none"
        opacity="0.05"
      />
    </svg>
  );
}

function CabinDivider({ className = "" }: { className?: string }) {
  return (
    <div className={`relative w-full overflow-hidden ${className}`} aria-hidden="true">
      <svg
        viewBox="0 0 1200 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto"
        preserveAspectRatio="none"
      >
        <line
          x1="0"
          y1="30"
          x2="440"
          y2="30"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.12"
        />
        <line
          x1="760"
          y1="30"
          x2="1200"
          y2="30"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.12"
        />
        <path
          d="M530 35 L540 15 L550 35"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          opacity="0.15"
        />
        <path
          d="M555 35 L570 8 L585 35"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          opacity="0.18"
        />
        <path
          d="M580 35 L590 18 L600 35"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          opacity="0.12"
        />
        <path
          d="M550 22 L570 5 L590 22 L550 22Z"
          stroke="currentColor"
          strokeWidth="1.2"
          fill="none"
          opacity="0.1"
        />
        <rect
          x="564"
          y="22"
          width="12"
          height="10"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
          opacity="0.08"
        />
        <path
          d="M460 38 Q530 32 600 35 Q670 38 740 35"
          stroke="currentColor"
          strokeWidth="0.8"
          fill="none"
          opacity="0.08"
        />
      </svg>
    </div>
  );
}

export { CabinLakescapeAccent, CabinDivider };
